import React from 'react';
import {
  Box,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { GenericModal } from './GenericModal';
import { SpecComments } from '../Spec';
import { SpecCommentsProps } from '../Spec/SpecComments';

interface SpecCommentsModalProps extends SpecCommentsProps {
  open: boolean
  onClose?(): void
}

export const SpecCommentsModal = (props: SpecCommentsModalProps) => {
  const { specId, onCommentRead, open, onClose } = props;
  return (
    <GenericModal
      open={open}
      onClose={onClose}
      fixExpand={true}
      size={800}
      header={
        !!specId && (
          <Box p={1}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <Typography color="primary" variant="h6">{specId}</Typography>
                  </Grid>
                  <Grid>
                    <Typography color="textSecondary" variant="h6">Notes</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <IconButton size="small" onClick={onClose}>
                  <Close />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        )
      }
    >
      {!!specId && (
        <Box height="100%" px={1}>
          <SpecComments specId={specId} onCommentRead={onCommentRead} />
        </Box>
      )}
    </GenericModal>
  );
};
